import { create } from 'zustand';

interface ApprovalBadgeState {
  count: number;
  setCount: (count: number) => void;
}

export const useApprovalBadgeStore = create<ApprovalBadgeState>((set) => ({
  count: 0,
  setCount: (count) => set({ count }),
}));
